import { t } from 'i18n';
import { useProductDetailState } from 'contexts';
import { useDetailPromotion } from 'hooks';
import React from 'react';
import { ProductDetailPromotion } from 'types';
import { RelatedPromotions, Title } from 'components/ProductDetail/styles';
import { RelatedPromotion } from 'components/RelatedPromotion';
import { Divider } from '@teko/ds-desktop';
import { DividerStyleEnum } from '@teko/types/shared';
import { RelatedPromotionV2 } from 'components/RelatedPromotionV2';

interface ProductRelatedPromotionProps {
  extraPromotions?: ProductDetailPromotion[];
}

export const ProductRelatedPromotions: React.FC<
  ProductRelatedPromotionProps
> = ({ extraPromotions }: ProductRelatedPromotionProps) => {
  const { product, price } = useProductDetailState();
  const { validPromotions } = useDetailPromotion(product, price?.finalPrice);
  const showAllPromotion = [...validPromotions, ...(extraPromotions || [])];

  return !!showAllPromotion?.length ? (
    <>
      <Divider
        dividerStyle={DividerStyleEnum.dashed}
        margin={['s12', 's0']}
        color="divider"
      />
      <RelatedPromotions className="BOXKHUYENMAILIENQUAN">
        <Title>{t('Khuyến mãi liên quan')}</Title>
        <ul>
          {validPromotions.map((promotion, index: number) => (
            <li key={index}>
              <RelatedPromotionV2 validPromotion={promotion} />
            </li>
          ))}
          {extraPromotions?.map((promotion, index: number) => (
            <li key={index}>
              <RelatedPromotion promotion={promotion} />
            </li>
          ))}
        </ul>
      </RelatedPromotions>
    </>
  ) : null;
};
